import { render, staticRenderFns } from "./PlayerTopImg.vue?vue&type=template&id=581b16a0"
import script from "./PlayerTopImg.vue?vue&type=script&lang=js"
export * from "./PlayerTopImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports